import React from 'react'
import { Navigate, Outlet, useParams } from 'react-router-dom'
import { useAuth } from 'utils/providers/AuthProvider'
import routes from 'constants/routes'
import { checkCampaignLocked } from 'utils/helpers'
import { getCampaign } from 'api/campaigns'
import { useQuery } from '@tanstack/react-query'

const CampaignGuard = () => {
  const { user } = useAuth()
  const { campaignId } = useParams()

  const { data: campaign, isLoading } = useQuery({
    queryKey: ['campaign', campaignId],
    queryFn: () => getCampaign(Number(campaignId)),
  })

  if (!user || isLoading) return null

  const isCampaignLocked = checkCampaignLocked(user.tierId, campaign?.tierId)

  if (!campaign || isCampaignLocked) {
    return <Navigate to={routes.pageNotFound} replace />
  }

  return <Outlet />
}

export default CampaignGuard
